import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import Columns from '../styles/columns'
import CardStyles from '../styles/cards'
import Card from '@material-ui/core/Card'
import { withStyles } from '@material-ui/core/styles'
import TitledLabel from '../controls/TitledLabel'
import Divider from '@material-ui/core/Divider'
import ClaimLineMessage from '../widgets/Claims/ClaimLineMessage'
import ClaimLinePayment from '../widgets/Claims/ClaimLinePayment'
import ClaimLinePractitioner from '../widgets/Claims/ClaimLinePractitioner'
import { injectIntl } from 'react-intl'
import { localize } from '../util/Localizer'
import Config from '../Config'
import { connect } from 'react-redux'
import { fetchClaimLines } from '../redux/actions/claimLineActions'
import Loading from '../widgets/Loading'
import BackButton from '../controls/BackButton'
import { fetchEOBFile } from '../redux/actions/eobActions'
import { formatCurrency } from '../util/CurrencyFormatter'
import { ClaimStatus } from '../redux/SubmitClaim/Common'
import classnames from 'classnames'
import ClaimReceipts from '../widgets/Claims/ClaimReceipts'

class ClaimLineDetails extends Component {
  constructor (props) {
    super(props)

    this.backToSummary = this.backToSummary.bind(this)
  }

  componentDidMount () {
    if (!this.props.claimLines || (this.props.claimLines.claimLines[0].claimId != this.props.claimId)) { // eslint-disable-line eqeqeq
      this.props.fetchClaimLines(this.props.claimId)
    }
  }

  backToSummary () {
    this.props.goBack()
  }

  render () {
    const { classes = {} } = this.props
    const claimLineId = parseInt(window.location.pathname.split('/').pop(), 10)

    let props = null
    if (!isNaN(claimLineId) && this.props.claimLines && Array.isArray(this.props.claimLines.claimLines)) {
      props = this.props.claimLines.claimLines.find(line => (line.claimLineId === claimLineId))
    }

    if (props) {
      const tpFormat = ClaimStatus.isPending(props.totalPayAmmount)
      return (
        <div className='claimLine'>
          <BackButton label={localize('pages.claimLines.backButton')} />

          <div className='pageContentClaimLineDetails'>
            <Row>
              <Col xs={12}>
                <p>{localize('pages.claims.claimLineDetails.claimNum')} {props.claimCode} - {props.benefitName}</p>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <div className='flex'>
                  <h4 className='sectionHeading'>{localize('pages.claims.claimLineDetails.titleDetail')}</h4>
                </div>
                <Card className={ classnames(classes.summaryCard, classes.baseCard) }>
                  <Row>
                    <Col {...Columns.max4}>
                      <TitledLabel title={localize('pages.claims.claimLineDetails.name')} format='text' value={props.patientName} />
                    </Col>
                    <Col {...Columns.max4} className='serviceDescription'>
                      <TitledLabel title={localize('pages.claims.claimLineDetails.serviceCodeDesc')} format='text' value={props.serviceCode} />
                      <p>{props.serviceCodeDescription}</p>
                    </Col>
                    <Col {...Columns.max4}>
                      <TitledLabel title={localize('pages.claims.claimLineDetails.status')} format='text' value={props.claimLineStatus} />
                    </Col>
                    <Col {...Columns.max4}>
                      <TitledLabel title={localize('pages.claims.claimLineDetails.relationshipCategory')} format='text' value={props.relationshipCategory} />
                    </Col>
                    <Col {...Columns.max4}>
                      <TitledLabel title={localize('pages.claims.claimLineDetails.processedDate')} format='date' value={props.processedDate} />
                    </Col>
                    <Col {...Columns.max4}>
                      <TitledLabel title={localize('pages.claims.claimLineDetails.serviceDate')} format='date' value={props.serviceDate} />
                    </Col>
                    <Col {...Columns.max4}>
                      <TitledLabel title={localize('pages.claims.claimLineDetails.payeeType')} format='text' value={props.payeeType} />
                    </Col>
                    <Col xs={12}>
                      <Divider />
                    </Col>
                    <Col xs={12} className='bold'>
                      <Row between='xs'>
                        <Col xs={12} sm={6} lg={9}>
                          <p>{localize('pages.claims.claimLineDetails.totalSubmit')}</p>
                        </Col>
                        <Col xs={12} sm={6} lg={3}>
                          <p>
                            {formatCurrency(props.submitedAmmount)}
                          </p>
                        </Col>
                      </Row>
                      <Row between='xs'>
                        <Col xs={12} sm={6} lg={9}>
                          <p>{localize('pages.claims.claimLineDetails.totalPay')}</p>
                        </Col>
                        <Col xs={12} sm={6} lg={3}>
                          <p>
                            {tpFormat ? <span>{props.totalPayAmmount}</span> : formatCurrency(props.totalPayAmmount)}
                          </p>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
            <Row className='claimLineMsgs'>
              <Col xs={12}>
                {props.explanationOfBenefits.length > 0 && <h4 className='sectionHeading'>{localize('pages.claims.claimLineDetails.titleMessages')}</h4>}
                {props.explanationOfBenefits.map((msg, i) => { return <ClaimLineMessage key={i} msg={msg.explanationOfBenefitsMessage} /> })}
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Divider />
                <div className='paymentInfo'>
                  {props.paymentInfo.map((payment, i) => { return <ClaimLinePayment key={i} payment={payment} /> })}
                  {(props.paymentInfo && !Config.hideClaimPaymentMessage) && (props.payeeType === 'Practitioner' || props.payeeType === 'Provider' || props.payeeType === 'Pourvoyeur' || props.payeeType === 'Praticien') && <ClaimLinePractitioner type={props.claimType} />}
                </div>
              </Col>
            </Row>
            <Row className='EOBmsgs'>
              <Col xs={12}>
                {props.explanationOfBenefitsFileExists === true ? <p>{localize('pages.claims.claimLineDetails.eobMsg')} <a href={`mailto:${Config.helpEmail}`}>{Config.helpEmail}</a></p> : null}
              </Col>
            </Row>
            {this.props.claimLines && this.props.claimLines.receipts.length > 0
              ? <Row >
                <Col xs={12}>
                  <ClaimReceipts claimLines={this.props.claimLines} />
                </Col>
              </Row> : null}
          </div>
        </div>
      )
    } else {
      return (
        <div className='pageContentClaimLineDetails'>
          <Loading message={localize('common.loadingContent')} />
        </div>
      )
    }
  }
}

function mapStateToProps (state, ownProps) {
  return {
    claimLines: state.ClaimLineReducer.claimLines,
    error: state.ClaimLineReducer.error,
    isLoading: state.ClaimLineReducer.isLoading,
    claimId: ownProps.claimId,
    downloadError: state.EOBReducer.error,
    eobFile: state.EOBReducer.eobFile || ''
  }
}

const ConnectedClaimLineDetails = connect(mapStateToProps, { fetchClaimLines, fetchEOBFile })(injectIntl(ClaimLineDetails))

const styles = {
  ...CardStyles
}

export default withStyles(styles)(ConnectedClaimLineDetails)



// WEBPACK FOOTER //
// ./src/components/ClaimLineDetails.js